/**
 * Desktop table with consistent sort-header styling.
 *
 * columns: Array<{ key: string, label: string, sortable?: boolean, render?: (row) => ReactNode }>
 * data:    Array of row objects
 * sortKey: currently sorted column key (optional)
 * sortDir: 'asc' | 'desc' (optional)
 * onSort:  (key: string) => void — called when a sortable header is clicked
 * className — extra class(es) on the <table>
 */
export default function Table({ columns, data, sortKey, sortDir, onSort, className = '' }) {
  const sortIndicator = (key) => {
    if (key !== sortKey) return null;
    return sortDir === 'asc' ? ' ▲' : ' ▼';
  };

  return (
    <div className="table-container">
      <table className={['data-table', className].filter(Boolean).join(' ')}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                onClick={col.sortable && onSort ? () => onSort(col.key) : undefined}
                className={col.sortable ? 'sortable-header' : undefined}
                aria-sort={
                  col.key === sortKey
                    ? sortDir === 'asc' ? 'ascending' : 'descending'
                    : undefined
                }
              >
                {col.label}
                {sortIndicator(col.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id ?? i}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
